import { useEffect } from "react";
import { Notification, useLocale } from "react-admin";
// Providers
import themeApp from "../providers/themeProvider";

// Material Components
import { ThemeProvider } from "@material-ui/core/styles";
import {
  makeStyles,
  Grid,
  Box,
  Paper,
  Typography,
  Hidden,
} from "@material-ui/core";
const themeConfig = require("../config/index").default;
// Assets
const lateralImg =
  require(`../assets/images/${themeConfig.companyLoginLateralImage}`).default;
const bigLogo =
  require(`../assets/images/${themeConfig.companyPrimaryLogo}`).default;
const themeFavicon =
  require(`../assets/images/${themeConfig.companyFavicon}`).default;

const useStyles = makeStyles((theme) => ({
  paper: {
    width: "100%",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    position: "absolute",
    overflowY: "auto",
    right: 0,
    top: 0,
    boxShadow: "-1px 4px 26px 0px rgba(0, 0, 0, 0.41)",
    height: "100vh",
    [theme.breakpoints.up("md")]: {
      width: "48%",
      borderRadius: "47px 0 0 47px",
    },
  },
  lateralImg: {
    width: "110%",
    height: "100vh",
    //backgroundImage: `url(${lateralImg})`,
    backgroundRepeat: "no-repeat",
    backgroundSize: "cover",
    "&::before": {
      content: "''",
      top: 0,
      left: 0,
      position: "absolute",
      width: "100%",
      height: "100vh",
      background: themeConfig.companyLoginLateralImageBg,
      //opacity: 0.7,
    },
    "& div": {
      color: "#fff",
      zIndex: 1,
    },
  },
  logo: {
    width: 410,
    maxHeight: 110,
    objectFit: "contain",
    [theme.breakpoints.down("xs")]: {
      width: 340,
    },
  },
}));

export function AuthLayout({ children }) {
  const classes = useStyles();
  const locale = useLocale();

  useEffect(() => {
    document.title = themeConfig.companyName.includes("Soldi")
      ? "Soldi Backoffice"
      : locale === "en"
        ? `Welcome to  ${themeConfig.companyName}`
        : `Bienvenido a ${themeConfig.companyName}`;

    let link = document.querySelector("link[rel~='icon']");
    if (!link) {
      link = document.createElement("link");
      link.rel = "icon";
      document.head.appendChild(link);
    }
    link.href = themeFavicon;
  }, [locale]);

  return (
    <ThemeProvider theme={themeApp}>
      <Grid container>
        <Hidden smDown>
          <Grid item md={6}>
            <Box
              display="flex"
              alignItems="center"
              justifyContent="center"
              flexDirection="column"
              className={classes.lateralImg}
            >
              <div style={{ height: '100%', width:'100%', display: 'flex', flexDirection: 'column', justifyContent: 'center', textAlign:'center'}}>
                <Typography
                  variant="h2"
                  style={{
                    fontSize: 60,
                    marginRight: 50,
                    fontWeight: 'bold',
                    textAlign: 'left',
                    marginLeft: 50
                  }}
                >
                  {locale === 'en' ? 'Welcome to' : 'Bienvenido a '}
                </Typography>
                <Typography
                  variant="h2"
                  style={{
                    fontSize: 60,
                    marginRight: 50,
                    fontWeight: 'bold',
                    textAlign:'left',
                    marginLeft: 50
                  }}
                >
                  <strong>{themeConfig.companyName}</strong>
                </Typography>
              </div>
              <div
                style={{
                  width: '100%',
                  zIndex: 0,
                  background: '#00D8D8',
                }}
              >
                <Typography
                  variant="h2"
                  style={{
                    fontSize: 15,
                    padding: 10,
                    textAlign: 'left',
                    marginLeft: 30,
                    fontWeight: '400',
                  }}
                >
                  Bancaribe C.A. - RIF J00002949-0 © 2022. Todos los derechos reservados.
                </Typography>
              </div>
            </Box>
          </Grid>
        </Hidden>

        <Grid item xs={12} md={6}>
          <Paper className={classes.paper}>
            <Box
              display="flex"
              alignItems="center"
              paddingBottom={5}
              paddingTop={10}
              justifyContent="flex-start"
              flexDirection="column"
              width="100%"
            >
              <Box style={{
                position: 'relative',
                marginBottom: 55,
              }}>
                <img
                  src={bigLogo}
                  alt="logo"
                  width="100%"
                  height="100%"
                  className={classes.logo}
                />
              </Box>

              {children}
            </Box>
          </Paper>
        </Grid>
      </Grid>
      <Notification autoHideDuration={2500} />
    </ThemeProvider>
  );
}  